import { render, staticRenderFns } from "./DailyBonusItem.vue?vue&type=template&id=a531a22e&scoped=true"
import script from "./DailyBonusItem.vue?vue&type=script&lang=js"
export * from "./DailyBonusItem.vue?vue&type=script&lang=js"
import style0 from "./DailyBonusItem.vue?vue&type=style&index=0&id=a531a22e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a531a22e",
  null
  
)

export default component.exports